import { styled } from '@mui/material/styles';
import { Backdrop, CircularProgress } from '@mui/material';

export const StyledBackDrop = styled(Backdrop)`
  background-color: rgba(0, 0, 0, 0.2);
`;
export const StyledCircularProgress = styled(CircularProgress)``;
